import useErrorHandler from "../FormErrorHandler";
import {
  FormInputRow,
  FormHeader,
  RadioInput,
} from "../../FormInput/FormInput";
import InjuriesInfoList from "../InjuriesInfoList";

const InjuriesInfo = ({ formData, handleInputChange, validateForm }) => {
  const { error, addError, clearError, hasError } = useErrorHandler();

  const handleInjuriesSelected = (fieldName, value, parentField) => {
    handleInputChange(fieldName, value, parentField);
    if (value == "No") 
      handleInputChange("injuriesInLossLists", null);
  };

  const validate = async (formData) => {
    clearError();
    let hasValidationError = false;

    if (!formData.wereThereAnyInjuriesInLoss) {
      addError({ wereThereAnyInjuriesInLoss: "This field is required" });
    } else if (formData.wereThereAnyInjuriesInLoss == "Yes") {
      let hasSetFocused = false;
      for (const person of formData.injuriesInLossLists) {
        if (typeof person.validate === "function") {
          const isValid = await person.validate(person);
          if (!isValid) {
            hasValidationError = true;
            if(!hasSetFocused){
              person.setIsFocused(true)
              hasSetFocused = true
            }
          }
        } else {
          hasValidationError = true;
        }
      }
    }

    return !hasError() && !hasValidationError;
  };

  validateForm.current = validate;

  return (
    <>
      <FormHeader>ADDITIONAL INFORMATION</FormHeader>
      <FormInputRow header="Were any other individuals injured in this loss?*">
        <RadioInput
          fieldName="wereThereAnyInjuriesInLoss"
          value={formData.wereThereAnyInjuriesInLoss}
          handleInputChange={handleInjuriesSelected}
          sameLine={true}
          error={error}
          options={[
            { label: "Yes", value: "Yes" },
            { label: "No", value: "No" },
          ]}
        />
      </FormInputRow>

      {formData.wereThereAnyInjuriesInLoss == "Yes" && (
        <InjuriesInfoList
          formData={formData}
          handleInputChange={handleInputChange}
          validateForm={validateForm}
        />
      )}
    </>
  );
};

export default InjuriesInfo;
